// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1SIxm","gfeWrapper":"CalendarEvent_gfeWrapper__2kBpQ"};